import MFormInput from './index.vue';

MFormInput.install = app => {
  app.component(MFormInput.name, MFormInput);
};

export default MFormInput;
